module.exports = __webpack_public_path__ + "assets/img/dzh-29.99abbc8c.gif";